'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z' });

var Videocam = function Videocam(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Videocam = (0, _pure2.default)(Videocam);
Videocam.muiName = 'SvgIcon';

exports.default = Videocam;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Videocam.js
// module id = 2980
// module chunks = 0